import { useContext, useEffect } from "react";
import PageContext from "../Context/PageContext";

function HistoryShortcuts() {
    const { history } = useContext(PageContext);

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            const target = e.target as HTMLElement;

            if (
                target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.isContentEditable
            ) {
                return;
            }

            const isMac = navigator.platform.toUpperCase().includes('MAC');
            const ctrlOrCmd = isMac ? e.metaKey : e.ctrlKey;

            if (!ctrlOrCmd) return;

            if (e.key === 'z' && !e.shiftKey) {
                e.preventDefault();
                history.canUndo && history.undo();
            }

            if (
                e.key === 'y' ||
                (e.key === 'z' && e.shiftKey)
            ) {
                e.preventDefault();
                history.canRedo && history.redo();
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [history]);

    return null;
}

export default HistoryShortcuts;